import { logger } from "@/src/lib/logging/logger";
import { isServer } from "@/src/lib/runtime";

export function getSessionItem(key: string): string | null {
  if (isServer) return null;
  try {
    return localStorage.getItem(key);
  } catch (e) {
    logger.warn("localStorage.getItem failed – filters may not persist", { context: "Filters", error: e });

    return null;
  }
}

export function setSessionItem(key: string, value: string): void {
  if (isServer) return;
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    logger.warn("localStorage.setItem failed – filters may not persist", { context: "Filters", error: e });
  }
}
